import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class GetOwnerCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IGetOwnerCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/vehicleOwners/{ownerId}';

  public override setParameters(parameters: IGetOwnerCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierId}',
      parameters.carrierId
    );
    this._commandUrl = this._commandUrl.replace(
      '{ownerId}',
      parameters.ownerId
    );
  }
}
export interface IGetOwnerCommandParameters extends ICommandParameters {
  carrierId: string;
  ownerId: string;
}
